import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArrowButton from '../../ArrowButton/ArrowButton';
import { HeaderText } from 'components/common/fontElements';
import { Header } from './CommonSelectTask.styles';

class CommonSelectTask extends Component {
  renderOptions() {
    const { taskInputs, setSelectedTask } = this.props;

    return taskInputs.map(({ title, id, dataProtected, sensitiveDataType }) => (
      <ArrowButton
        label={title}
        onClickFunction={() => setSelectedTask(id)}
        disabled={false}
        key={id}
        dataProtected={dataProtected}
        sensitiveDataType={sensitiveDataType}
      />
    ));
  }

  render() {
    return (
      <div>
        <Header>
          <HeaderText>Actions</HeaderText>
        </Header>
        {this.renderOptions()}
      </div>
    );
  }
}

CommonSelectTask.propTypes = {
  taskInputs: PropTypes.array.isRequired,
  setSelectedTask: PropTypes.func.isRequired,
};

export default CommonSelectTask;
